'use client';
import Link from 'next/link';
import { ButtonShadcn } from '@/components/ui/button-shadcn';
import {
  CATEGORY_TRANSLATIONS,
  SupportedLang,
} from '@/utils/postsTranslations';

interface Category {
  id: number;
  slug: string;
  name: string;
}

interface CategoryFilterProps {
  categories: Category[];
  selectedCategory: string | null;
  currentLang: SupportedLang;
}

export default function CategoryFilter({
  categories,
  selectedCategory,
  currentLang,
}: CategoryFilterProps) {
  const allLabel = currentLang === 'ru' ? 'Все' : 'All';

  const createCategoryUrl = (categorySlug: string | null) => {
    if (categorySlug) {
      // Use the appropriate language route structure
      return currentLang === 'ru' 
        ? `/posts/ru/category/${categorySlug}`
        : `/posts/category/${categorySlug}`;
    } else {
      // "All" goes back to main posts page
      return currentLang === 'ru' ? '/posts/ru' : '/posts';
    }
  };

  return (
    <div className='w-full mb-6'>
      <div className='flex flex-wrap gap-2'>
        <Link href={createCategoryUrl(null)}>
          <ButtonShadcn
            variant={selectedCategory === null ? 'secondary' : 'outline'}
            size='sm'
          >
            {allLabel}
          </ButtonShadcn>
        </Link>

        {categories.map((category) => {
          const translatedName =
            CATEGORY_TRANSLATIONS[category.slug]?.[currentLang] ||
            category.name;

          return (
            <Link key={category.id} href={createCategoryUrl(category.slug)}>
              <ButtonShadcn
                variant={
                  selectedCategory === category.slug ? 'secondary' : 'outline'
                }
                size='sm'
              >
                {translatedName}
              </ButtonShadcn>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
